module.exports = __webpack_public_path__ + "static/media/Kevin.db8fd51c.png";